import React, { useContext, useEffect, useState } from 'react';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import { Triangle } from 'react-loader-spinner';
import { GetData } from "../Api";
import FilterContext from "../Hooks/Context";
import Grid from '../Views/Grid'
import { useTranslation } from "react-i18next";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { addDays} from "date-fns";
import enUS from "rsuite/locales/en_US";
import zhLocale from "rsuite/locales/zh_CN";

import Dropdown from "../Components/ReportsDropdown";
import TextField from "@mui/material/TextField";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import MobileDateTimePicker from "@mui/lab/MobileDateTimePicker";
import DesktopDateTimePicker from "@mui/lab/DesktopDateTimePicker";
import { MultiSelect } from "react-multi-select-component";
import moment from 'moment';
import $ from "jquery";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { CONSTANTS } from '../Api/Constants';
moment.suppressDeprecationWarnings = true;



const TargetVsActual = () => {

  const filterQueries = useContext(FilterContext);
  const [currentLanguage, SetCurrentLanguage] = useState();
  const [reportData, SetReportData] = useState();
  const [isReportChanged, SetIsReportChanged] = useState();
  const { t } = useTranslation();
  const [language, SetLanguage] = useState();
  const [startValue, setStartValue] = useState();
  const [endValue, setEndValue] = useState();
  const [selected, setSelected] = useState([]);
  const [selectedMachines, SetSelectedMachines] = useState();
  const [ loaderVisiblity, SetLoaderVisiblity ] = useState(false);
  const [nilData, SetNilData] = useState(false);
  const [startOfTheDay, SetStartOfTheDay] = useState();
  const [endOfTheDay, SetEndOfTheDay] = useState();
  const [updateMultiSelect, SetUpdateMultiSelect] = useState();
  const [multiselect, SetMultiSelect] = useState(true);
  const [toggleLineDropdown, SetToggleLineDropDown] = useState(false);
  const [options, SetOptions] = useState([
    { label: "Complete Line", value: "completedCounts", title: "" },
    { label: "Printer", value: "printer", title: "Printer" },
    { label: "SPI", value: "spi", title: "SPI" },
    { label: "Pre-AOI", value: "preaoi", title: "Pre-AOI" },
    { label: "Post-AOI", value: "postaoi", title: "Post-AOI" },
  ]);
  const [chineseOptions, SetChineseOptions] = useState([
    { label: "整线", value: "completedCounts", title: "" },
    { label: "打印机", value: "printer", title: "Printer" },
    { label: "SPI", value: "spi", title: "SPI" },
    { label: "前AOI", value: "preaoi", title: "Pre-AOI" },
    { label: "后AOI", value: "postaoi", title: "Post-AOI" },
  ]);
  const [requestParameters, SetRequestParameters] = useState({
    'factory': '1',
    'line': '1',
    'startTs': '',
    'endTs': '',
    'shift': '',
    'machines': '',
    'shiftData': '1'
  });
  const { i18n } = useTranslation('TargetVsActual');

  const [shiftData, SetShiftData] = useState([
    { id: "1", label: "All Shift" },
    { id: "2", label: "Shift A" },
    { id: "3", label: "Shift B" }
  ]);

  /* Mock data for dropdown */
  const factoryData = [
    { id: "1", label: "Select Factory" },
    { id: "2", label: "All Factories" },
    { id: "3", label: "Flexunion" }
  ];

  const masterLineDropDownData = [
    { id: "1", label: "Select Line" },
    { id: "2", label: "All Lines" },
    { id: "3", label: "Line 2" }
  ];

  const [lineDropdownData, SetLineDropdownData] = useState([
    { id: "1", label: "Select Line" },
    { id: "2", label: "All Lines" },
    { id: "3", label: "Line 2" }
  ]);

  let AllLinesData = [
    { id: "1", label: "All Lines" }
  ];

  let shiftMatchData = {
    "A" : "Shift A",
    "B" : "Shift B"
  };

  const columns = [
    { dataField: 'factory_name', text: 'Factory', sort: true },
    { dataField: 'line_name', text: 'Line', sort: true },
    { dataField: 'date', text: 'Date', sort: true },
    { dataField: 'shift', text: 'Shift', sort: true },
    { dataField: 'program_name', text: 'Machine Name', sort: true },
    { dataField: 'target_qty', text: 'Target Quantity', sort: true },
    { dataField: 'actual_qty', text: 'Actual Quantity', sort: true },
    { dataField: 'delivered_percent', text: 'Delivery %', sort: true }
  ];

  const chineseColumns = [
    { dataField: 'factory_name', text: '工厂', sort: true },
    { dataField: 'line_name', text: '线', sort: true },
    { dataField: 'date', text: '日期', sort: true },
    { dataField: 'shift', text: '转移', sort: true },
    { dataField: 'program_name', text: '机器名称', sort: true },
    { dataField: 'target_qty', text: '目标数量', sort: true },
    { dataField: 'actual_qty', text: '实际数量', sort: true },
    { dataField: 'delivered_percent', text: '交货 ％', sort: true }
  ];

  const GetReportsData = (startOfTheDay, endOfTheDay, selectedMachines) => {
    if (
      filterQueries &&
      filterQueries.filterRequestQuery !== null &&
      filterQueries.filterRequestQuery !== undefined
    ) {
      GetData(
        `report/target-actual?startTs=${startOfTheDay}&endTs=${endOfTheDay}&factoryId=&lineId=&device=${selectedMachines}&shift=${requestParameters.shift}`
      )
        .then((response) => {
          let updatedData = JSON.parse(JSON.stringify(response.data));
          updatedData.map((item, index) => {
            item.date = moment().utc(item.date).format('MM/DD/YYYY');
            item.shift = shiftMatchData[item.shift];
            item.target_qty = "N/A";
            item.delivered_percent = "N/A";
          })
          SetReportData(updatedData);
          SetIsReportChanged(true);
          SetLoaderVisiblity(false);
          return response.data;
        })
        .then((data) => {
        })
        .catch((error) => {
          SetNilData(true);
          SetLoaderVisiblity(false);
        });
    }
  };

  useEffect(() => {

    let updatedValue = new Date();
    let sDate = updatedValue;
      sDate.setHours(CONSTANTS.SHIFT.ENDHOUR)
      sDate.setMinutes(CONSTANTS.SHIFT.ENDMIN)
      sDate.setSeconds(CONSTANTS.SHIFT.ENDSEC)
    
    let eDate = addDays(updatedValue, 1);
      eDate.setHours(CONSTANTS.SHIFT.ENDHOUR)
      eDate.setMinutes(CONSTANTS.SHIFT.ENDMIN)
      eDate.setSeconds(CONSTANTS.SHIFT.ENDSEC)
    setStartValue(sDate);
    setEndValue(eDate);

  }, []);

  useEffect(() => {

      FormatMultiSelectOptions();

  }, [selected]);

  useEffect(() => {

    if(requestParameters.factory.toString() >= '2') {
        SetMultiSelect(false);
    } else {
      SetMultiSelect(true);
    }

  }, [requestParameters]);

  useEffect(() => {
    setSelected([]);
   }, [i18n.language]);

  const FormatMultiSelectOptions = () => {

    var completedCounts = selected.filter(obj => obj.value === "completedCounts");
    let selectedOptionsi18n = i18n.language === 'en'? options : chineseOptions;

    selectedOptionsi18n.map((item, index) => {
      item.disabled = false;
    });
    if (completedCounts.length === 1) {
      selectedOptionsi18n.map((item, index) => {
        if (item.value !== "completedCounts")
          item.disabled = true;
          else 
          item.disabled = false;
      })
    }

    var otherCounts = selected.filter(obj => obj.value !== "completedCounts");
    if (otherCounts.length >= 1) {
      selectedOptionsi18n.map((item, index) => {
        if (item.value === "completedCounts")
          item.disabled = true;
        else 
          item.disabled = false;
      })
    }

    if(i18n.language === 'en') {
      SetOptions(selectedOptionsi18n);
    } else {
      SetChineseOptions(selectedOptionsi18n);
    }
    SetUpdateMultiSelect(!updateMultiSelect);

  }

  const GenerateReport = () => {

    SetLoaderVisiblity(true);
    let startOfTheDay = Math.floor(
      Date.UTC(
        startValue.getFullYear(),
        startValue.getMonth(),
        startValue.getDate(),
        startValue.getHours(),
        startValue.getMinutes(),
        1
      ) / 1000
    );

    let endOfTheDay = Math.floor(
      Date.UTC(
        endValue.getFullYear(),
        endValue.getMonth(),
        endValue.getDate(),
        endValue.getHours(),
        endValue.getMinutes(),
        0
      ) / 1000
    );

    let selectedMachines = "";
    selected.map((option, index) => {
      if (option.label === "Completed Counts") {
        selectedMachines = selectedMachines + "";
      } else {
        if (selectedMachines === "") {
          selectedMachines = selectedMachines + (option.title).toLowerCase();
        } else {
          selectedMachines = selectedMachines + "," + (option.title).toLowerCase();
        }
      }
    });

    SetSelectedMachines(selectedMachines);
    SetStartOfTheDay(startOfTheDay);
    SetEndOfTheDay(endOfTheDay);
    GetReportsData(startOfTheDay, endOfTheDay, selectedMachines);

  }

  const localeMap = {
    en: enUS,
    zh: zhLocale,
  };

  const SetFilterValue = (label, id, name) => {

    if(name === 'factory') {
      if(label !== 'Select Factory') {
        SetToggleLineDropDown(true);
      } else {
        SetToggleLineDropDown(false);
      }

      if(id === '2') {
        SetLineDropdownData(AllLinesData);
      } else {
        SetLineDropdownData(masterLineDropDownData);
      }
    }

    if (name === 'shift') {
      let shiftData = {
        "1": "",
        "2": "A",
        "3": "B"
      }
      SetRequestParameters(
        {
          ...requestParameters,
          'shift': shiftData[id],
          'shiftData': id,
          'label': label
        });
    } else {
      SetRequestParameters(
        {
          ...requestParameters,
          [name]: id,
          'label': label
        });
    }

  }

  const exportPDF = () => {

    $("#GenerateButton").hide();
    html2canvas($("#filterGroup")[0]).then((canvas) => {
      let canvasImage = canvas.toDataURL(); //image data of canvas
      const unit = "pt";
      const size = "A4"; // Use A1, A2, A3 or A4
      const orientation = "portrait"; // portrait or landscape
      const marginLeft = 40;
      const doc = new jsPDF(orientation, unit, size);
      doc.setFontSize(9);
      const title = `TARGET V/S ACTUAL REPORT`;
      const headers = [["Factory", "Line", "Date", "Shift", "Machine Name", "Target Quantity", "Actual Quantity", "Delivery %" ]];
      const data = reportData.map(elt=> [elt.factory_name, elt.line_id, elt.date, elt.shift, elt.program_name, elt.target_qty, elt.actual_qty, elt.delivered_percent]);
      let content = {
        startY: 110,
        head: headers,
        body: data
      };
      doc.text(title, marginLeft, 40);
      doc.addImage(canvasImage, 'JPEG', 40, 50, 500, 45)
      doc.autoTable(content);
      doc.save(`TARGET V/S ACTUAL OUTPUT`)
      $("#GenerateButton").show();
    });

  }

  const OnMultiSelectLoad = () => {

    console.log(selected);

  }

  return (
    <div key={isReportChanged}>
      <h4>{t("LT_target_v_s_actual_output")}</h4>
      <div id="filterGroup">
      <div className="filter-container" key={ lineDropdownData.length } >
        <Dropdown
          selectedLanguage={language}
          data={factoryData}
          placeholder={t("LT_select_factory")}
          selectedItem={factoryData[requestParameters.factory - 1]}
          name="factory"
          parentSelector={SetFilterValue}
          width={"140px"}
        />
       { toggleLineDropdown && <Dropdown
          data={lineDropdownData}
          placeholder={t("LT_select_line")}
          selectedItem={lineDropdownData[requestParameters.factory  === '2' ? 0 : requestParameters.line - 1]}
          name="line"
          parentSelector={SetFilterValue}
          width={"90px"}
        /> }

        <LocalizationProvider
          key={language}
          dateAdapter={AdapterDateFns}
          locale={localeMap[currentLanguage]}
        >
          <div className="mobile-only">
            <MobileDateTimePicker
              value={startValue}
              maxDate={new Date()}
              onChange={(newValue) => {
                setStartValue(newValue);
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </div>
          <div className="desktop-only">
            <DesktopDateTimePicker
              value={startValue}
              maxDate={new Date()}
              onChange={(newValue) => {
                setStartValue(newValue);
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </div>
          <div className="mobile-only">
            <MobileDateTimePicker
              minDate={startValue}
              maxDate={addDays(startValue, 1)}
              value={endValue}
              onChange={(newValue) => {
                setEndValue(newValue);
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </div>
          <div className="desktop-only">
            <DesktopDateTimePicker
              minDate={startValue}
              maxDate={new Date()}
              value={endValue}
              onChange={(newValue) => {
                setEndValue(newValue);
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </div>
        </LocalizationProvider>

        <Dropdown
          data={shiftData}
          placeholder={t("LT_select_line")}
          selectedItem={shiftData[requestParameters.shiftData - 1]}
          name="shift"
          parentSelector={SetFilterValue}
          width={"80px"}
        />
        <div>
          <MultiSelect
          options={i18n.language === 'en' ? options : chineseOptions}
          value={selected}
          onChange={setSelected}
          labelledBy="Select Machines"
          className="multi-select"
          hasSelectAll={false}
          onMenuToggle={ OnMultiSelectLoad }
          disabled={ multiselect }
        />
        </div>

        <button id="GenerateButton" className="generate-btn" onClick={GenerateReport} disabled={ selected.length >= 1 ? false : true }>
          { t("LT_generate") }
        </button>

      </div>

        {selected && selected.length >= 1 && <div className='report-selected'>{selected.length ? (
          <div>
            <br />
            <ul>
              <li className='selected-machines'>{ t("Selected Machines") }: </li>
              {selected.map((option, index) =>
                <li key={option.value}>
                  {option.label} {index !== selected.length - 1 ? "," : ""}
                </li>
              )}
            </ul>
          </div>) : ''
        }
        </div>}
      </div>


      <br />
      { nilData && <div className='no-data-available'>{t("LT_no_data_available")}</div>}
      {loaderVisiblity && <div className="loader">
        <Triangle arialLabel="loading-indicator" color="#002E5B" width="120" height="120" />
        <span className='loading-span'>{t("LT_loading")}...</span>
      </div>}
      {reportData && <div className='reports-container'>
        <div className='reports-container-heading'>
          <div className='report-table-subheading'>{ t("LT_target_v_s_actual_output_report") }</div>
          <div>
            { t("LT_view") }
            &nbsp;
            <i className="fa fa-file-pdf-o download-icon" onClick={() => exportPDF()} aria-hidden="true"
            ></i>
            <br/>
          </div>
        </div>
        <Grid gridData={reportData} gridColumns={ i18n.language === 'en' ?  columns : chineseColumns } name="Target v/s Actual Output Report" />
      </div>}
    </div>
  );
};

export default TargetVsActual;
